import { ContentType } from '@/@types/common'
import type { PostType } from '@/@types/post'

export const POST_TYPE_TO_ROUTE_MAPPING: Record<PostType, 'post' | 'repost'> = {
	ORIGINAL_POST: 'post',
	REPOST: 'repost',

	//@fixme personal update 不一定是 post
	PERSONAL_UPDATE: 'post',
}

export const ROUTE_TO_POST_TYPE_MAPPING: Record<'post' | 'repost', PostType> = {
	post: ContentType.POST,
	repost: ContentType.REPOST,
}
